import { Action } from 'redux';
import { PushAction } from 'redux-little-router';
import { Epic, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { changeLocation } from '../../../actions/common';
import { FILTER_INTERNAL_MARKETERS } from '../../../actions/marketers/internal/filterInternalMarketers';
import { EpicDeps } from '../../../service/StoreFactory';
import { State } from '../../../typings/state';

type EpicActions = PushAction;

export const filterInternalMarketersEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FILTER_INTERNAL_MARKETERS),
        switchMap(
            (): Observable<EpicActions> => {
                const state = store$.value;
                const { router } = state;
                const ulogin = (router.query && router.query.ulogin) || '';

                return of(changeLocation(router.pathname, { ulogin }, false));
            }
        )
    );
};
